import { startSeries } from '~/elc/features/library/util';
import Urls from '~/urls';

export const startOrContinueGuide = (guideId: string, assignmentId?: string) => {
  const url = assignmentId ? Urls.guideContinueAssignment(assignmentId) : Urls.guideStart(guideId);
  window.location.assign(url);
};
export const previewGuide = (guideId: string) => {
  window.location.assign(`/guides/${guideId}/preview/`);
};

export const startOrContinueChallenge = (challengeId: string, assignmentId?: string) => {
  const url = assignmentId ? Urls.challengeContinueAssignment(assignmentId) : Urls.challengeStart(challengeId);
  window.location.assign(url);
};
export const previewChallenge = (challengeId: string) => {
  window.location.assign(`/challenges/${challengeId}/preview/`);
};

export const startOrContinueSCORM = (scormId: string, openInNewTab = false) => {
  const url = Urls.topLevelContentStartOrContinueAssignment('scorm', scormId);
  window.open(url, openInNewTab ? '_blank' : '_self');
};

export const startOrContinuePath = (path: any, trainingClassSessionAttendeesByEventId?: any) => {
  const assignmentId = path.trainingSeriesUserAssignments?.[0]?.id;
  if (assignmentId) {
    window.location.assign(`/paths/${path.id}/start`);
    return;
  }

  // startSeries takes a LibrarySeries object, but path is the content of a SavedContent
  startSeries({
    id: path.id,
    name: path.displayTitle,
    description: path.description,
    cardBanner: path.cardBanner,
    uiOrder: null,
    dateCreated: null,
    dateUpdated: null,
    folderId: null,
    libraryId: null,
    tags: path.objectTags,
    seriesId: path.id,
    timeEstimateSeconds: path.timeEstimateSeconds,
    assignments: [],
    type: 'series',
    progress: null,
    numModules: path.numAssets,
    seriesAssignmentForUser: [],
    trainingClassSessionAttendeesByEventId,
    skills: path.skills || [],
  });
};

export const viewResource = (resourceId: string) => {
  window.location.assign(`/resources/${resourceId}`);
};

export const viewLibraryFolder = (universityId: string, folderId: string) => {
  window.location.assign(`libraries/${universityId}/content?university_folder_id=${folderId}`);
};

export const viewDevelopmentContent = (developmentContentId: string) => {
  window.location.assign(`development/${developmentContentId}`);
};

export const viewCMSFile = (cmsFileId: string) => {
  window.open(`/cms_files/view?id=${cmsFileId}`, '_self');
};

export const viewCMSLink = (cmsLinkId: string) => {
  window.open(`/cms_links/view?id=${cmsLinkId}`, '_blank');
};
